import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import firebaseService from '../../services/firebase-service';
import { detectIncognito } from 'detectincognitojs';


const NotificationPermissionDialog = () => {
  const [open, setOpen] = useState(false);
  const [permissionState, setPermissionState] = useState(null);
  const [isIncognito, setIsIncognito] = useState(false);

  useEffect(() => {
    // Sử dụng thư viện detectIncognito để kiểm tra chế độ ẩn danh
    detectIncognito()
      .then(result => {
        // result.isPrivate = true nếu đang ở chế độ ẩn danh
        setIsIncognito(result.isPrivate);
        console.log('Chế độ ẩn danh:', result.isPrivate, 'Trình duyệt:', result.browserName);
        
        // Chỉ kiểm tra quyền nếu không ở chế độ ẩn danh
        if (!result.isPrivate) {
          checkNotificationPermission();
        }
      })
      .catch(error => {
        console.error('Lỗi khi phát hiện chế độ ẩn danh:', error);
        // Nếu lỗi, giả định không phải chế độ ẩn danh
        checkNotificationPermission();
      });
    
    // Kiểm tra mỗi khi người dùng quay lại trang
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        detectIncognito()
          .then(result => {
            setIsIncognito(result.isPrivate);
            if (!result.isPrivate) {
              checkNotificationPermission();
            }
          })
          .catch(() => {
            // Nếu lỗi, giả định không phải chế độ ẩn danh
            checkNotificationPermission();
          });
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // Kiểm tra trạng thái của quyền thông báo
  const checkNotificationPermission = () => {
    // Kiểm tra nếu không có API thông báo hoặc ở chế độ ẩn danh
    if (isIncognito || !('Notification' in window)) {
      return;
    }
    
    // Lấy trạng thái quyền hiện tại
    const permission = Notification.permission;
    setPermissionState(permission);
    
    try {
      // Kiểm tra xem người dùng đã chọn "Không hiển thị lại" chưa
      const dontShowAgain = sessionStorage.getItem('notification_prompt_dont_show_again');
      
      // Chỉ hiển thị dialog khi quyền bị denied và chưa chọn "Không hiển thị lại"
      if (permission === 'denied' && dontShowAgain !== 'true') {
        setOpen(true);
      }
    } catch (e) {
      // Lỗi khi truy cập sessionStorage, có thể do đang ở chế độ ẩn danh
      console.log('Không thể truy cập sessionStorage');
    }
  };

  // Xử lý khi người dùng đồng ý bật thông báo
  const handleEnable = () => {
    // Mở cài đặt thông báo của trình duyệt (chỉ hoạt động trên một số trình duyệt)
    if (navigator.permissions) {
      navigator.permissions.query({ name: 'notifications' }).then((result) => {
        if (result.state === 'denied') {
          // Mở hướng dẫn về cách bật thông báo
          alert('Vui lòng làm theo các bước sau để bật thông báo:\n\n1. Nhấp vào biểu tượng khóa/thông tin bên cạnh URL\n2. Tìm mục "Thông báo/Notifications"\n3. Thay đổi thành "Cho phép"');
        }
      });
    }
    
    // Đóng dialog
    setOpen(false);
    
    // Thử yêu cầu quyền thông báo lại (trong trường hợp trạng thái là 'default')
    if (permissionState === 'default') {
      firebaseService.requestPermissionAndGetToken();
    }
  };

  // Xử lý khi người dùng từ chối và chọn không hiển thị lại
  const handleDontShowAgain = () => {
    sessionStorage.setItem('notification_prompt_dont_show_again', 'true');
    setOpen(false);
  };

  // Xử lý khi người dùng đóng dialog
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="notification-permission-dialog-title"
      aria-describedby="notification-permission-dialog-description"
    >
      <DialogTitle id="notification-permission-dialog-title">
        Bật thông báo từ ứng dụng
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="notification-permission-dialog-description">
          Để nhận thông báo quan trọng từ hệ thống, ACE cần cho phép thông báo từ trình duyệt. 
          {permissionState === 'denied' ? 
            ' ACE đã từ chối thông báo trước đó. Vui lòng bật lại trong cài đặt trình duyệt.' : 
            ' Nhấn "Bật thông báo" để cho phép.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDontShowAgain} color="primary">
          Không hiển thị lại
        </Button>
        <Button onClick={handleClose} color="primary">
          Để sau
        </Button>
        <Button onClick={handleEnable} color="primary" variant="contained" autoFocus>
          Bật thông báo
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationPermissionDialog;
